import { render, staticRenderFns } from "./CompanyInfo_UploadLedger.vue?vue&type=template&id=250b054b&scoped=true"
import script from "./CompanyInfo_UploadLedger.vue?vue&type=script&lang=js"
export * from "./CompanyInfo_UploadLedger.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo_UploadLedger.vue?vue&type=style&index=0&id=250b054b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250b054b",
  null
  
)

export default component.exports